import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { IQRBatchBrandItem } from '../../qr-products.interface';
import { BaseResponse } from '@shared/base/base-response';
import { BaseService } from '@services/base-service.service';
import { API } from '@config/constants/api.constant';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ProductBrandService } from '@services/product-brand.service';
import { ModalConfig } from '@shared/components/modal/modal.interface';

@Component({
  selector: 'app-input-listbox-brand',
  templateUrl: './input-listbox-brand.component.html',
  styleUrls: ['./input-listbox-brand.component.scss'],
})
export class InputListboxBrandComponent implements OnInit {
  @ViewChild('modalForm') private modalForm: ModalComponent;
  modalConfig: ModalConfig = {
    modalTitle: 'Pilih Produk',
    disableCloseButton: () => !this.listSelectedItems.value.length,
    onClose: () => {
      this.clearSearchKeyword();
      return true;
    },
  };

  listItems = new BehaviorSubject<IQRBatchBrandItem[]>([]);
  listSelectedItems = new BehaviorSubject<IQRBatchBrandItem[]>([]);
  listItems$: Observable<BaseResponse<IQRBatchBrandItem[]>>;

  searchKeyword: string = '';
  loading = new BehaviorSubject(true);

  @Output() selectedItems = new EventEmitter();

  // other config
  @Input() shouldEmitChips = false;
  @Input() ctaLabel = 'Tambahkan';
  @Input() maxSelectChips: number;

  constructor(private baseService: BaseService, private productBrandService: ProductBrandService) {}

  ngOnInit() {
    this.getListBoxData();
  }

  open(sync = true) {
    if (!sync) this.handleSyncData();
    return this.modalForm.open();
  }

  getListBoxData(sync = false) {
    this.loading.next(true);
    this.listItems$ = this.baseService.getData<IQRBatchBrandItem[]>(API.LIST_BRAND_QR_BATCH_ADD);
    this.listItems$.subscribe((list) => {
      if (!list) {
        return;
      }

      let { data } = list;
      const _excludedEmptyName = data.filter((item) => item.name != null && item.name !== '');
      _excludedEmptyName.map((el) => (el.selected = false));

      data = _excludedEmptyName;
      this.listItems.next(data);

      if (sync) {
        this.repopulateListItems();
      }

      this.loading.next(false);
    });
  }

  handleDataOutput(items: IQRBatchBrandItem[]) {
    this.listSelectedItems.next(items);
    this.ctaLabel = 'Simpan';

    this.listItems.value.map((_listItem) => {
      items.forEach((item) => {
        if (item.id === _listItem.id) {
          _listItem.selected = item.selected;
        }
      });
    });
  }

  handleAddItems() {
    this.selectedItems.emit(this.listSelectedItems);
    return this.modalForm.dismiss().then(() => this.clearSearchKeyword());
  }

  handleChangeSelection() {
    this.listSelectedItems.next(this.listItems.value.filter((item) => item.selected));
    this.ctaLabel = 'Tambahkan';
  }

  handleSyncData() {
    this.loading.next(true);
    this.productBrandService.syncBrand().subscribe((res) => {
      if (!res) return;

      this.getListBoxData(true);
      this.loading.next(false);
    });
  }

  repopulateListItems() {
    const listItems = this.listItems.value;
    const selectedItems = this.listSelectedItems.value;

    selectedItems.forEach((_selectedItem) => {
      listItems.map((_listItem) => {
        if (_listItem.id === _selectedItem.id) {
          _listItem.selected = _selectedItem.selected;
        }
      });
    });

    this.listItems.next(listItems);
    this.handleChangeSelection();
  }

  numOfSelectedChipsIsValid() {
    return this.maxSelectChips ? this.listSelectedItems.value.length < this.maxSelectChips : true;
  }

  clearSearchKeyword = () => (this.searchKeyword = '');

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
